import { Link, useNavigate } from 'react-router-dom';
import { KeyRound, UserCog, ChevronRight } from 'lucide-react';
import AuthShell from '../../components/AuthShell';

export default function RecuperarAcesso() {
    const navigate = useNavigate();
    return (
        <AuthShell>
            <div className="ueb-auth-card">
                <h1>Recuperar acesso</h1>
                <p className="ueb-auth-sub">Como você quer recuperar o acesso à sua conta?</p>

                <button className="ueb-choice" onClick={() => navigate('/esqueci-senha')}>
                    <span className="ueb-choice-ico"><KeyRound size={20} /></span>
                    <span className="ueb-choice-txt">
                        <strong>Esqueci minha senha</strong>
                        <small>Já tenho email cadastrado e quero criar uma nova senha.</small>
                    </span>
                    <ChevronRight size={18} className="pfaint" />
                </button>

                <button className="ueb-choice" onClick={() => navigate('/recuperar-conta')}>
                    <span className="ueb-choice-ico"><UserCog size={20} /></span>
                    <span className="ueb-choice-txt">
                        <strong>Recuperar conta</strong>
                        <small>Sou aluno antigo, ainda sem email/senha. Quero ativar meu acesso.</small>
                    </span>
                    <ChevronRight size={18} className="pfaint" />
                </button>

                <p className="ueb-auth-foot"><Link className="plink" to="/login">Voltar ao login</Link></p>
            </div>
        </AuthShell>
    );
}
